module.exports = __webpack_public_path__ + "img/logo_aera.795b471a.png";